export const formatCurrency = (value) => {
  if (value === null || value === undefined) return '$ -';
  return `$ ${Number(value).toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatPercentage = (value) => {
  if (value === null || value === undefined) return '-';
  return `${Number(value).toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatNumber = (value) => {
  if (value === null || value === undefined) return '-';
  return `${Number(value).toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
